// Native details is the no-JS implementation. Explicit state is kept in sync
// only while this enhancement is active (including after bfcache restoration).
(function () {
  function initialize(root) {
    root.querySelectorAll('.gurmeo-nutrition-label__panel').forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;
      function sync() { summary.setAttribute('aria-expanded', String(details.open)); }
      if (!details.dataset.ariaReady) {
        details.dataset.ariaReady = 'true';
        summary.setAttribute('role', 'button');
        details.addEventListener('toggle', sync);
      }
      sync();
    });
  }
  initialize(document);
  window.addEventListener('pageshow', function () { initialize(document); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
